import dayjs from 'dayjs';

import { Measurement } from '../../http/meas-service';
import { toDepth } from '../../utils/depth';
import { TableMode } from './table-mode';

function q(value: string | number): string {
    if (value === '') return '';
    return `"${value}"`;
}

function numStr(n: number): string {
    return n.toFixed(2).replace('.', ',');
}

function row(...cells: (string | number)[]): string {
    return cells.map(q).join(';');
}

export function buildCsv(measurements: Measurement[], mode: TableMode): string {
    const lines: string[] = [];

    if (mode === TableMode.Normal) {
        const maxCols = measurements.reduce((max, m) => Math.max(max, m.values.length), 0);
        lines.push(row(
            'Устройство', 'Датчик', 'Время',
            ...Array.from({ length: maxCols }, (_, i) => i + 1),
        ));

        for (const m of measurements) {
            const values = m.values.map(numStr);
            while (values.length < maxCols) values.push('');
            lines.push(row(m.device, m.sensor, dayjs(m.measure).format('DD.MM.YYYY HH:mm'), ...values));
        }
    } else {
        lines.push(row('Устройство', 'Серийный номер', 'Время', 'Датчик', 'Глубина', 'Показание'));

        for (const m of measurements) {
            const time = dayjs(m.measure).format('DD.MM.YYYY HH:mm');
            for (let i = 0; i < m.values.length; i++) {
                const depth = i < m.depths.length ? numStr(toDepth(m, i)) : '';
                lines.push(row(m.device, m.sensor, time, i + 1, depth, numStr(m.values[i])));
            }
        }
    }

    return lines.join('\r\n');
}

export function downloadCsv(csv: string, filename: string): void {
    const bom = '﻿'; // UTF-8 BOM — Excel корректно открывает кириллицу
    const blob = new Blob([bom + csv], { type: 'text/csv;charset=utf-8;' });
    const url = URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = url;
    a.download = filename;
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
    URL.revokeObjectURL(url);
}

export function buildFilename(mode: TableMode): string {
    const ts = dayjs().format('YYYY-MM-DD_HH-mm');
    const suffix = mode === TableMode.Normal ? 'сводная' : 'детальная';
    return `замеры_${ts}_${suffix}.csv`;
}
